const filters = {
	query: '',
	show_filters: false,
	filters: {
		year_established: 2020,
		park_area: 45000
	}
}

export default filters;


// WEBPACK FOOTER //
// ./src/data/filters.js